<template>
  <el-drawer
    :visible.sync="getVisible"
    direction="rtl"
    :size="drawerSize"
    :with-header="false"
    custom-class="mch-group-drawer"
    append-to-body
    destroy-on-close
  >
    <div class="drawer-header">
      <div class="drawer-title-wrap">
        <span class="drawer-title-icon"><i :class="type === 'edit' ? 'el-icon-edit-outline' : 'el-icon-plus'"></i></span>
        <span class="drawer-title">{{ type === 'edit' ? '编辑商户组' : '新增商户组' }}</span>
        <div class="drawer-header-actions">
          <el-button size="small" icon="el-icon-back" :disabled="saveLoading" @click="getVisible = false">返回列表</el-button>
          <el-button type="success" size="small" :loading="saveLoading" :disabled="saveLoading" @click="onSubmit">保存</el-button>
        </div>
      </div>
      <el-button size="small" icon="el-icon-close" class="drawer-close-btn" aria-label="关闭" @click="getVisible = false"></el-button>
    </div>

    <div class="drawer-content">
    <el-form :model="form" :rules="rules" ref="form" label-position="right" label-width="150px" size="small" class="drawer-horizontal-form">
      <el-form-item label="商户组 ID" prop="id">
        <el-input type="number" v-model.number="form.id" :disabled="type === 'edit'" placeholder="请输入商户组 ID"></el-input>
      </el-form-item>

      <el-form-item label="商户类型" prop="type">
        <el-select v-model="form.type" @change="typeChange(form.type)" placeholder="请选择商户类型">
          <el-option v-for="item in merchantType" :key="item.value" :label="`${item.value} - ${item.label}`" :value="item.value"/>
        </el-select>
      </el-form-item>

      <el-form-item label="默认商户 ID (AppId)" prop="appId">
        <el-select v-model="form.appId" @change="mchAppIdChange(form.appId)" placeholder="请选择商户 ID" filterable>
          <el-option v-for="item in merchantList" :key="item.value" :label="`${item.label}`" :value="item.value"/>
        </el-select>
      </el-form-item>

      <el-form-item label="商户组名称" prop="name">
        <el-input v-model="form.name" placeholder="请输入商户组名称"></el-input>
      </el-form-item>

      <el-form-item label="随机商户开关" prop="open">
        <el-switch v-model="form.open" active-color="#10b981" inactive-color="#ef4444" />
      </el-form-item>

      <el-form-item label="随机商户配置" prop="data" style="margin-top: 15px;">
        <div class="mch-table-container">
          <el-table :data="form.data" stripe class="premium-table inline-edit-table" size="mini" max-height="250">
            <el-table-column align="left" prop="id" label="XP-商户ID" min-width="200">
              <template slot-scope="{row}">
                <el-select size="mini" v-model="row.appId" style="width: 100%;" placeholder="选择商户">
                  <el-option v-for="item in merchantList" :key="item.value" :label="`${item.label}`" :value="item.value"/>
                </el-select>
              </template>
            </el-table-column>
            <el-table-column align="left" prop="weight" label="权重" min-width="120">
              <template slot-scope="{row}">
                <el-input-number size="mini" v-model="row.weight" style="width: 100%;" :min="1" placeholder="权重" />
              </template>
            </el-table-column>
            <el-table-column align="center" fixed="right" label="操作" width="80">
              <template slot-scope="{$index}">
                <el-button type="danger" size="mini" circle icon="el-icon-delete" plain @click="$delete(form.data, $index)"></el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="mch-action-bar" style="margin-top: 10px;">
          <el-button size="mini" icon="el-icon-plus" @click="form.data.push({ appId: '', weight: 1 })" class="btn-add-row">添加随机商户行</el-button>
        </div>
      </el-form-item>
    </el-form>
    </div>
    <div class="drawer-footer">
      <el-button size="small" @click="getVisible = false">取 消</el-button>
      <el-button type="primary" size="small" :loading="saveLoading" :disabled="saveLoading" @click="onSubmit" class="btn-save">保 存</el-button>
    </div>
  </el-drawer>
</template>

<script>
import Api from '../../api/channel'
export default {
  name: 'MchGroupDialog',
  props: { visible: Boolean, formData: Object, type: String, updateFun: { type: Function, default: () => () => {} } },
  data () {
    return {
      merchantType: [
        { value: 1, label: '微信' },
        { value: 2, label: '支付宝' }
      ],
      merchantList: [],
      saveLoading: false,
      form: {
        data: []
      }
    }
  },
  computed: {
    getVisible: {
      get () { return this.visible },
      set (val) { return this.$emit('update:visible', val) }
    },
    drawerSize () {
      return window.innerWidth <= 768 ? '100%' : '50%'
    },
    rules () {
      return {
        id: [{ type: 'number', required: true, message: '请输入数字，且不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '请输入商户组名称', trigger: 'blur' }],
        type: [{ required: true, message: '请选择商户类型', trigger: 'change' }],
        appId: [{ required: true, message: '请选择商户ID', trigger: 'change' }],
        data: [{ validator: this.dataValidator, trigger: 'change' }]
      }
    }
  },
  watch: {
    formData: {
      async handler (nVal) {
        const form = JSON.parse(JSON.stringify(nVal))
        if (nVal.type) await this.getMerchantList(nVal.type)

        this.form = { ...form, data: form.data ?? [], open: !!form.open }
      },
      deep: true
    },
    visible (nVal) {
      if (!nVal) {
        const data = this.$options.data()
        this.merchantList = data.merchantList
      }
    }
  },
  methods: {
    dataValidator (_rule, value, cb) {
      const { open } = this.form
      if (open) {
        if (!value.length) return cb(new Error('随机商户不能为空 !'))
      }
      cb()
    },
    mchAppIdChange (id) {
      const obj = this.merchantList.find((item) => item.value === id)
      if (obj) {
        this.$set(this.form, 'name', obj.label)
      }
    },
    typeChange (type) {
      this.$set(this.form, 'data', [])
      this.$set(this.form, 'appId', '')

      this.getMerchantList(type)
    },
    async getMerchantList (type) {
      const hashRequest = {
        1: Api.getMchWxList,
        2: Api.getMchAliList
      }
      if (Reflect.has(hashRequest, type)) {
        await hashRequest[type]().then(res => {
          this.merchantList = res.reduce((pre, cur) => {
            return [...pre, { ...cur, label: `${cur.appId} - ${cur.name}`, value: cur.appId }]
          }, [])
        })
      }
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) return false

        const hashRequest = {
          add: Api.addMchGroup,
          edit: Api.changeMchGroup
        }
        if (Reflect.has(hashRequest, this.type)) {
          const { data, open } = this.form
          this.saveLoading = true
          hashRequest[this.type]({ ...this.form, open: +open, data: JSON.stringify(data) }).then(() => {
            const successType = { add: '新增成功！', edit: '修改成功！' }
            this.$message.success(successType[this.type])
            this.getVisible = false
            this.$emit('saved')
            this.updateFun()
          }).finally(() => {
            this.saveLoading = false
          })
        }
      })
    }
  }
}
</script>

<style scoped>
:deep(.mch-group-drawer) {
  background: #f8fafc;
}

:deep(.mch-group-drawer .el-drawer__body) {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
  padding: 14px 20px;
  border-bottom: 1px solid #e2e8f0;
  background: #ffffff;
}

.drawer-title-wrap {
  min-width: 0;
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
}

.drawer-header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-left: auto;
}

.drawer-header-actions .el-button + .el-button {
  margin-left: 0;
}

.drawer-title-icon {
  width: 28px;
  height: 28px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border-radius: 8px;
  background: rgba(37, 99, 235, 0.08);
  color: var(--primary-color);
}

.drawer-title {
  color: #1e293b;
  font-size: 15px;
  font-weight: 700;
}

.drawer-close-btn {
  display: none !important;
  width: 32px !important;
  height: 32px !important;
  padding: 0 !important;
  border-color: #e2e8f0 !important;
  border-radius: 8px !important;
  color: #64748b !important;
}

.drawer-content {
  flex: 1;
  overflow-y: auto;
  margin: 12px;
  padding: 20px;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #ffffff;
}

.drawer-horizontal-form :deep(.el-form-item) {
  display: flex;
  align-items: flex-start;
  margin-bottom: 18px;
}

.drawer-horizontal-form :deep(.el-form-item__label) {
  width: 150px !important;
  flex: 0 0 150px;
  padding: 0 16px 0 0;
  color: #475569;
  font-weight: 600;
  line-height: 32px;
  text-align: left;
}

.drawer-horizontal-form :deep(.el-form-item__content) {
  min-width: 0;
  flex: 1;
  margin-left: 0 !important;
}

.drawer-horizontal-form :deep(.el-select),
.drawer-horizontal-form :deep(.el-input),
.drawer-horizontal-form :deep(.el-input-number) {
  width: 100%;
}

.drawer-horizontal-form :deep(.el-input__inner),
.drawer-horizontal-form :deep(.el-textarea__inner) {
  border-color: #e2e8f0;
  border-radius: 8px;
}

.drawer-horizontal-form :deep(.el-input__inner:focus),
.drawer-horizontal-form :deep(.el-textarea__inner:focus) {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.08);
}

.drawer-footer {
  display: none;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  flex-shrink: 0;
  padding: 14px 20px;
  border-top: 1px solid #e2e8f0;
  background: #ffffff;
}

.drawer-footer .el-button + .el-button {
  margin-left: 0;
}

.btn-save {
  background-color: var(--primary-color) !important;
  border-color: var(--primary-color) !important;
  font-weight: 600 !important;
}

.btn-save:hover {
  background-color: var(--primary-hover) !important;
  border-color: var(--primary-hover) !important;
}

.mch-table-container {
  border: 1px solid #E2E8F0;
  border-radius: 8px;
  overflow: hidden;
}

.premium-table {
  border: none !important;
}

.premium-table::before {
  display: none !important;
}

.inline-edit-table :deep(.el-input__inner) {
  border-radius: 6px;
  border-color: #E2E8F0;
}

.inline-edit-table :deep(.el-input__inner:focus) {
  border-color: var(--primary-color);
}

.btn-add-row {
  background-color: #F8FAFC !important;
  border-color: #E2E8F0 !important;
  color: var(--primary-color) !important;
  border-radius: 6px !important;
  font-weight: 600 !important;
}

.btn-add-row:hover {
  background-color: #F1F5F9 !important;
  border-color: #CBD5E1 !important;
}

@media (max-width: 768px) {
  .drawer-content {
    margin: 8px;
    padding: 16px;
  }

  .drawer-horizontal-form :deep(.el-form-item) {
    display: block;
  }

  .drawer-horizontal-form :deep(.el-form-item__label) {
    width: 100% !important;
    padding-right: 0;
  }
}
</style>
